// extracted by mini-css-extract-plugin
export default {"close":"close__UcGau","centered":"centered__J8Pto","disabled":"disabled__MUBlQ"};